import * as React from "react";
import * as ReactDatetimeClass from "react-datetime";
import * as moment from "moment";
import * as classNames from "classnames";
import { controlColumnClass, labelColumnClass } from "../consts";

interface DateTimeComponentProps {
  className?: string;
  readOnly: boolean;
  dateFormat: string;
  dateTitle: string;
  dateTextBox: boolean;

  timeFormat: string;
  timeTitle: string;
  timeTextBox: boolean;
}

interface DateTimeComponentActions {
  onBlur(): void;
  onChange(value: string): void;
  onFocus(): void;
}

export type DateTimeComponentPropsAndActions = DateTimeComponentProps & DateTimeComponentActions;

interface IDateTimeComponentState {
  date: string,
  time: string
}

class DateTimeComponent extends React.PureComponent<DateTimeComponentPropsAndActions, IDateTimeComponentState> {
  constructor(props: DateTimeComponentPropsAndActions) {
    super(props);

    this.state = {
      date: moment().format(this.props.dateFormat),
      time: moment().format(this.props.timeFormat)
    };

    this.onDateChange = this.onDateChange.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);
    this.updateValue = this.updateValue.bind(this);
  }

  onDateChange(val: string | moment.Moment) {
    const newDate = moment(val).format(this.props.dateFormat);

    this.setState({ date: newDate });
  }

  onTimeChange(val: string | moment.Moment) {
    const newTime = moment(val).format(this.props.timeFormat);

    this.setState({ time: newTime });
  }

  componentDidUpdate(prevProps: DateTimeComponentPropsAndActions, prevState: IDateTimeComponentState) {
    if (!this.props.readOnly
      && (prevState.date != this.state.date || prevState.time != this.state.time)) {
      this.updateValue();
    }
  }

  componentDidMount() {
    // update stored redux value, for when the control has a default value
    this.updateValue();
  }

  updateValue() {
    if (this.state.date && this.state.time) {
      this.props.onChange(`${this.state.date} ${this.state.time}`);
    }
  }

  render() {

    const validDate = function (current) {
      return current.isBefore(moment());
    };

    return (
      <>
        <label className={classNames("lead my-0", labelColumnClass)}>{this.props.dateTitle}</label>
        <div className={classNames(controlColumnClass)}>
          <ReactDatetimeClass
            defaultValue={moment()}
            input={this.props.dateTextBox}
            inputProps={{
              placeholder: this.props.dateFormat,
              className: classNames("form-control", controlColumnClass)
            }}
            onBlur={this.props.onBlur}
            onChange={this.onDateChange}
            onFocus={this.props.onFocus}
            dateFormat={true}
            timeFormat={false}
            viewMode={"days"}
            isValidDate={validDate.bind(this)}
          />
        </div>

        <label className={classNames("lead mt-3 mb-0", labelColumnClass)}>{this.props.timeTitle}</label>
        <div className={classNames("mt-md-3 mb-0", controlColumnClass)}>
          <ReactDatetimeClass
            defaultValue={moment()}
            input={this.props.timeTextBox}
            inputProps={{
              placeholder: this.props.timeFormat,
              className: classNames("form-control", controlColumnClass)
            }}
            onBlur={this.props.onBlur}
            onChange={this.onTimeChange}
            onFocus={this.props.onFocus}
            dateFormat={false}
            timeFormat={true}
            viewMode={"time"}
          />
        </div>
      </>
    );
  }
}

export default DateTimeComponent;